import { JSX } from 'react'

import { LogOut } from 'lucide-react'

import { Button } from '~/components/component-library'
import { useLogout } from '~/hooks/useLogout'

export const LogoutButton = (): JSX.Element => {
  const logout = useLogout()
  return (
    <Button onClick={logout} variant={'secondary'}>
      <LogOut className="size-5 text-secondary" />
      <div>Log out</div>
    </Button>
  )
}
